import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import {a11yProps, TabPanel} from 'layouts/components/Tabs'
import {useAppDispatch, useAppSelector} from 'store/hooks'
import {setSettingTab} from 'store/dashboardSlice'
import * as Styles from 'layouts/PrivateLayout.styles'
import Table from 'components/ui/Table'
import {IUsers, useGetLogsQuery, useGetUsersQuery} from 'services/teamMembers'
import {useEffect, useState} from 'react'
import {Typography} from '@mui/material'
import {useNavigate} from 'react-router-dom'
import RangePicker from "../../../components/ui/RangePicker";
import {format} from 'date-fns';

const Settings = () => {
  const navigate = useNavigate();
  const { settingTab } = useAppSelector((state) => state.dashboard);
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(1);
  const [users, setUsers] = useState<any>({});
  const [limit] = useState(10);
  const [logsPage, setLogsPage] = useState(1);
  const [limitLogs] = useState(10);

  const today = new Date();
  const formattedToday = format(today, 'yyyy-MM-dd');
  const [startDate, setStartDate] = useState(formattedToday);
  const [endDate, setEndDate] = useState(formattedToday);

  const {
    data: logsData,
    isLoading: isLoadingLogs,
    isFetching: isFetchingLogs,
    refetch: refetchLogs
  } = useGetLogsQuery({
    limit: limitLogs,
    page: logsPage,
    startDate,
    endDate
  });

  const handleChangeTab = (_event: React.SyntheticEvent, newValue: number) => {
    dispatch(setSettingTab(newValue));
  };

  const {
    data: usersData,
    isLoading: isLoadingUsers,
    isFetching: isFetchingUsers
  } = useGetUsersQuery({ limit, page });

  useEffect(() => {
    setUsers(usersData?.users);
  }, [usersData]);

  useEffect(() => {
    refetchLogs();
  }, [startDate, endDate, refetchLogs]);

  const teamColumns = [
    {
      field: 'full_name',
      headerName: 'Team member name',
      render: (data: IUsers) => data.full_name
    },
    {
      field: 'username',
      headerName: 'Email',
      render: (data: IUsers) => data.username
    },
    {
      field: 'type',
      headerName: 'Role',
      render: (data: IUsers) =>
        data.type.charAt(0).toUpperCase() + data.type.slice(1)
    }
  ]

  const logsColumns = [
    {
      field: 'user_name',
      headerName: 'User'
    },
    {
      field: 'action',
      headerName: 'Action',
      render: (data: any)=> {
          try {
            return data.comments
          } catch (error) {
            console.error('Error formatting date:', error);
            return 'Invalid Date';
          }
        }
      },
      {
      field: 'date',
      headerName: 'Date',
      render: (data: any) => {
        // Safely parse the date and format it
        try {
          const date = new Date(data.created_at);
          console.log(data)
          return format(date, 'MMM dd, yyyy HH:mm:ss');
        } catch (error) {
          console.error('Error formatting date:', error);
          return 'Invalid Date';
        }
      }
    }
  ];

  const handleUserRowClick = (id: number) => {
    const user = users.filter((user: any) => {
      return user.id === id;
    });

    if (user.length > 0) {
      navigate(`/admin/settings/user/${user[0].username}`);
    }
  };
  return (
    <div>
      <div className="mt-3">
        <Styles.PageTitleContainer>Settings</Styles.PageTitleContainer>
      </div>
      <div className="mt-8">
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
              value={settingTab}
              onChange={handleChangeTab}
              aria-label="Settings tabs"
          >
            <Tab label="Team" {...a11yProps(0)} />
            <Tab label="Logs" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={settingTab} index={0}>
          <Table
            columns={teamColumns}
            rows={usersData?.users || []}
            showPagination
            page={page}
            setPage={setPage}
            onPrevPage={() => setPage(page - 1)}
            onNextPage={() => setPage(page + 1)}
            totalPages={Math.ceil(Number(usersData?.users) / limit)}
            emptyTitleText="No team members yet"
            emptyText=""
            isFetching={isFetchingUsers || isLoadingUsers}
            usePointer
            onRowClick={handleUserRowClick}
          />
        </TabPanel>
        <TabPanel value={settingTab} index={1}>
          <Styles.CreateEditPageTitleContainer sx={{paddingBottom: 3}}>
            <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
            >
              Most recent actions performed on the site will appear here
            </Typography>
            <RangePicker
                startDate={startDate}
                endDate={endDate}
                setStartDate={(date) => setStartDate(format(new Date(date), 'yyyy-MM-dd'))}
                setEndDate={(date) => setEndDate(format(new Date(date), 'yyyy-MM-dd'))}
            />
          </Styles.CreateEditPageTitleContainer>
          <Table
              columns={logsColumns}
              rows={logsData?.logs || []}
              showPagination
              page={logsPage}
              setPage={setLogsPage}
              onPrevPage={() => setLogsPage(logsPage - 1)}
              onNextPage={() => setLogsPage(logsPage + 1)}
              totalPages={Math.ceil(Number(logsData?.records_count || 0) / limitLogs)}
              emptyTitleText="No logs available yet"
              emptyText=""
              isFetching={isFetchingLogs || isLoadingLogs}
              usePointer
          />
        </TabPanel>
      </div>
    </div>
  )
}

export default Settings
